(function () {
  // Horizontal multi-card slider of reviews (mirrors popular-products): Swiper with
  // `slidesPerView: 'auto'` reads the CSS-computed card widths; `has-overflow` adds the peek only
  // when there are more reviews than columns at the current breakpoint.
  const initSlider = (section) => {
    if (!section || !section.classList.contains("testimonials-section")) return;

    const layout = section.querySelector(".testimonials__layout");
    if (!layout) return;

    const track = layout.querySelector(".testimonials__track");
    if (!track || track.children.length < 2) return;

    const perRow = Number(layout.dataset.reviewsPerRow || 1);

    // Breakpoints reviews can grow across, capped at `perRow` (matches the inline `--per-row` CSS).
    const breakpoints = [
      { bp: 0, cols: 1 },
      { bp: 750, cols: 2 },
      { bp: 1200, cols: 3 },
      { bp: 1536, cols: 4 },
    ].filter((step) => step.cols <= perRow);

    const currentCols = () => {
      let cols = 1;
      breakpoints.forEach((step) => {
        if (window.innerWidth >= step.bp) cols = step.cols;
      });
      return cols;
    };

    const updateOverflow = () => {
      const slides = track.querySelectorAll(".testimonial").length;
      layout.classList.toggle("has-overflow", slides > currentCols());
    };

    new Swiper(layout, {
      slidesPerView: "auto",
      spaceBetween: 16,
      speed: 1200,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        750: {
          spaceBetween: 24,
        },
      },
      on: {
        init: updateOverflow,
        resize: updateOverflow,
      },
    });
  };

  initSlider(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSlider(event.target);
  });
})();
